import React from 'react'

export default class ChatHeader extends React.Component {
  render() {
    const { host } = this.props
    return (
      <div className="chat-header">
        <h1>
          {this.props.bot.title}
          <span className="controls">
            <span className="btn close" onClick={() => this.props.onClose()} />
          </span>
        </h1>
      </div>
    )
  }
}
